import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { ExternalLink, Logo } from '~/components';

import { contentStyle, headerContainerStyle, headerStyle, layoutStyle, logoStyle } from './QuotationForClientLayout.css';

export const QuotationForClientLayout = () => {
  const { t } = useTranslation(['auth']);

  return (
    <div className={layoutStyle}>
      <header className={headerStyle}>
        <div className={headerContainerStyle}>
          <ExternalLink aria-label={t('auth:logo')} href="https://www.creativeshelter.be">
            <Logo className={logoStyle} />
          </ExternalLink>
        </div>
      </header>

      <main className={contentStyle}>
        <Outlet />
      </main>
    </div>
  );
};
